import { EmailAlertsWidget } from 'www/modules/email-alerts/email-alerts-widget';
import { ViewportSizeChange } from 'www/observables/viewport-size-change';
import { distinctUntilChanged } from 'rxjs/operators';
import AddCircleSVG from 'www/svg-icons/add-circle';
import CheckmarkCircleSVG from 'www/svg-icons/checkmark-circle';

export class PromosEmailAlertsWidget extends EmailAlertsWidget{
	constructor(){
		super();
	}
    init() {
        this.el.classList.add('medscape-email-alerts-widget');
        this.linkEl.insertAdjacentElement("afterbegin", this.iconContainer);
        this.linkEl.insertAdjacentElement("beforeend", this.labelContainer);
        super.init();
        ViewportSizeChange.pipe(
            distinctUntilChanged(null,data=>{
                return data.breakpoint;
            })
        )
        .subscribe(data=>{
            this.handleViewportSizeChange(data);
        })
    }

    get labelText() {
        const locale = window.locale || 'en';
        let labelText = "";

        if (this.api.state.isSubscribed) {
            labelText = this.breakpoint>1 ? super.labelText : "Email Alerts";
        } else {
            labelText = this.breakpoint>1 ? super.labelText : "Email Alerts";
        }

        return labelText.toUpperCase();
    }
    get icon() {
        let icon = null;
        if (this.api.state.isSubscribed) {
            icon = CheckmarkCircleSVG.useSprite;
        } else {
            icon = AddCircleSVG.useSprite;
        }
        return icon;
    }
    get labelContainer() {
        if (this._labelContainer == null) {
            let labelContainer = document.createElement('span');
            labelContainer.classList.add('label-container');
            labelContainer.innerHTML = this.labelText;
            this._labelContainer = labelContainer;
        }
        return this._labelContainer;
    }

    get iconContainer() {
        if (this._iconContainer == null) {
            let iconContainer = document.createElement('span');
            iconContainer.classList.add('icon-container');
            iconContainer.appendChild(this.icon);
            this._iconContainer = iconContainer;
        }
        return this._iconContainer;
    }
    handleViewportSizeChange(data){
        this.labelContainer.innerHTML = this.labelText;
    }
    handleSubscriptionUpdate(isSubscribed = this.api.state.isSubscribed) {
        if (isSubscribed) {
            this.linkEl.classList.add('is-subscribed');
        } else {
            this.linkEl.classList.remove('is-subscribed');
        }
        this.labelContainer.innerHTML = this.labelText;
        this.iconContainer.firstChild.remove();
        this.iconContainer.appendChild(this.icon);
        super.handleSubscriptionUpdate(isSubscribed);
    }

}

